import React from 'react';
import { connect } from 'react-redux';
import DetailFieldRoleComponent from './DetailFieldRoleComponent';
import roleOperations from 'pages/Role/duck/operations';
import { appOperations } from 'App/duck';

const mapStateToProps = ({
  appReducer,
  locationReducer,
}) => {
  return {
    roles: appReducer.roles.data,
    locationId: locationReducer.location_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  const loadLocationRolesDispatch = (locationId) => {
    dispatch(appOperations.fetchLocationRolesOperation(locationId));
  };

  const updateRoleDispatch = (roleId, colorCode, locationId) => {
    dispatch(roleOperations.updateRoleOperation(roleId, colorCode, locationId));
  };

  const addRoleDispatch = (roleName, colorCode, locationId, selectRoleCallback) => {
    dispatch(roleOperations.addRoleOperation(roleName, colorCode, locationId, selectRoleCallback));
  };

  return {
    loadLocationRolesDispatch,
    updateRoleDispatch,
    addRoleDispatch,
  };
};

const DetailFieldRoleContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    roles,
    locationId,
    loadLocationRolesDispatch,
    updateRoleDispatch,
    addRoleDispatch,
    selectedRole,
    selectRoles,
    roleDisplayText,
    disableField,
    ...rest
  } = props;

  const handleColorSelect = (color) => {
    if (selectedRole && selectedRole.id) {
      updateRoleDispatch(selectedRole.id, color, locationId);
    }
  };

  const handleCreateRole = (roleName, colorCode, selectRoleCallback) => {
    if (roleName && colorCode) {
      addRoleDispatch(roleName, colorCode, locationId, selectRoleCallback);
    }
  };

  return (
    <DetailFieldRoleComponent
      roles={roles}
      locationId={locationId}
      selectedRole={selectedRole}
      selectRoles={selectRoles}
      roleDisplayText={roleDisplayText}
      disableField={disableField}
      onColorSelect={handleColorSelect}
      onCreateRole={handleCreateRole}
      {...rest}
    />
  );
});

export default DetailFieldRoleContainer; 